webpackJsonp([263791100135453],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: #3a87ad;\n'], ['\n  color: #3a87ad;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(105);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SiteLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject);
	
	exports.default = SiteLink;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(56);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    "ul",
	    null,
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { to: "/about/me" },
	        "Me"
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { to: "/about/initial-consultation" },
	        "Initial Consultation"
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { to: "/about/origins-of-chiropractic" },
	        "Origins of Chiropractic"
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { to: "/about/what-is-mctimoney" },
	        "What is McTimoney?"
	      )
	    ),
	    _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { to: "/about/privacy-notice" },
	        "Privacy Notice"
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-ad11e6c791183eb29837.js